import { Injectable } from '@angular/core';

const LANGUAGE_COOKIE_NAME = 'language';

@Injectable({
  providedIn: 'root',
})
export class LanguageSettingsService {
  public storeLanguage(language: string, reload: boolean = true): void {
    const cookieOpts = [
      'max-age=31536000',
      'path=/',
    ];
    if (location.protocol === 'https:') {
      cookieOpts.push('Secure', 'SameSite=None');
    }
    document.cookie = `${LANGUAGE_COOKIE_NAME}=${language}; ${cookieOpts.join('; ')}`;

    if (reload) {
      const newUrl = location.href.replace(/;lang=[^;/]*/g, '');
      history.replaceState(null, '', newUrl);
      document.location.reload();
    }
  }
}
